export default {"src":"/_next/static/media/anxietyanddepression.e435e881.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};